import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { StoragePublicLinkDto, StorageUploadLinkDto } from '../dto';
import { StorageUploadLink } from '../model';
import { GenericStorageApiService } from './generic-storage-api.service';
import { GenericApiOption } from '@core/generic-api/data-access';

@Injectable({ providedIn: 'root' })
export class StorageApiService extends GenericStorageApiService {
  UPLOAD_LINK = 'storage/upload/:type';
  PUBLIC_LINK = 'storage/link';

  getUploadLink(dto: StorageUploadLinkDto, requestOption?: GenericApiOption): Observable<StorageUploadLink> {
    return this.api.get(this.UPLOAD_LINK, dto, requestOption).pipe(map(res => StorageUploadLink.fromJson(res)));
  }

  getPublicLink(data: StoragePublicLinkDto, requestOption?: GenericApiOption): Observable<string> {
    return this.api.get(this.PUBLIC_LINK, data, requestOption);
  }
}
